import { REGEX } from "../lib/regex";

export function isEmpty(value: any) {
  return value === undefined || value === null || value === '';
}

export function formatStringForTemplating(str: string): string {
  let stringToFormat = str;
  if (isUUID(stringToFormat) || /^\d/.test(stringToFormat)) {
    stringToFormat = `i_${stringToFormat}`;
  }
  return stringToFormat.replace(/[^a-zA-Z0-9]/g, '_').toLowerCase();
}

export function isUUID(str: string): boolean {
  return REGEX.UUID.test(str);
}
